import { memo } from "react";
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Badge from '@mui/material/Badge';
import AddCommentIcon from '@mui/icons-material/AddComment';
import { useActionContext, useCommentContext } from "../../providers";

const Comment = () => {
    const { comments } = useCommentContext();
    const { comment } = useActionContext();

    return (
        <ListItem
            disablePadding
        >
            <Badge
                color='info'
                badgeContent={comments.length}
            >
                <ListItemButton
                    onPointerDown={comment}
                >
                    <ListItemIcon>
                        <AddCommentIcon
                            color='warning'
                        />
                    </ListItemIcon>
                    <ListItemText
                        sx={{
                            color: 'warning.main'
                        }}
                        primary='Request changes / Comment'
                    />
                </ListItemButton>
            </Badge>
        </ListItem>
    );
};

export default memo(Comment);
